import { Context } from "./Reducers/Store";
import { useContext } from "react";
import { Navigate } from "react-router-dom";

function RequireAdmin({ children }) {
  const [state] = useContext(Context);

  if (!state.profile?.isAdministrator) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default RequireAdmin;
